const listOfBookChapters = [
  {
    id: 1,
    year: 2022,
    submenu: [
      {
        title:
          "Wearable Real-Time Epileptic Seizure Detection and Warning System.",
        author:
          "Chowdhury, Muhammad EH, Amith Khandakar, Khawla Alzoubi, Aisha Mohammed, Safaa Taha, Aya Omar, Khandaker R. Islam et al.",
        details:
          "In Biomedical Signals Based Computer-Aided Diagnosis for Neurological Disorders, pp. 233-265. Springer, Cham, 2022.",
        doi: "https://doi.org/10.1007/978-3-030-97845-7_11",
      },
      {
        title: "Biosignal time-series analysis",
        author:
          "Kiranyaz, Serkan, Turker Ince, Muhammad EH Chowdhury, Aysen Degerli, and Moncef Gabbouj. ",
        details:
          "In Deep Learning for Robot Perception and Cognition pp. 491-539. Academic Press, 2022.",
        doi: "https://doi.org/10.1016/B978-0-32-385787-1.00024-5",
      },
    ],
  },
  {
    id: 2,
    year: 2021,
    submenu: [
      {
        title:
          "Future Techniques and Perspectives on Implanted and Wearable Heart Failure Detection Devices",
        author: `Muhammad E. H. Chowdhury, Amith Khandakar, Yazan Qiblawey, ..., Khandaker Reajul Islam,`,
        details: " In book: Predicting Heart Failure.",
        doi: "https://doi.org/10.1002/9781119813040.ch13",
      },

      {
        title: "Tomato Leaf Diseases Detection Using Deep Learning Technique",
        author:
          "Chowdhury, Muhammad EH, Tawsifur Rahman, Amith Khandakar, Nabil Ibtehaz, Aftab Ullah Khan, Muhammad Salman Khan, Nasser Al-Emadi, Mamun Bin Ibne Reaz, Mohammad Tariqul Islam, and Sawal Hamid Md Ali.",
        details: "(2021). (Web of Science indexed).",
        doi: "https://www.intechopen.com/chapters/76494",
      },
    ],
  },
  {
    id: 3,
    year: 2020,
    submenu: [
      {
        title:
          "Photo-Voltaic (PV) Monitoring System, Performance Analysis and Power Prediction Models ",
        author:
          "Touati, Farid, Amith Khandakar, Muhammad E.H. Chowdhury, S. P. Antonio Jr, Christian Kim Sorino, and Kamel Benhmed. ",
        details:
          "Doha, Qatar.In Renewable Energy. IntechOpen, 2020. (Web of Science indexed).",
        doi: "https://www.intechopen.com/chapters/72280",
      },
      {
        title: `Machine Learning in Wearable Biomedical Systems.`,
        author:
          "Chowdhury, Muhammad E.H., Amith Khandakar, Yazan Qiblawey, Mamun Bin Ibne Reaz, Mohammad Tariqul Islam, and Farid Touati. ",
        details:
          "In Sports Science and Human Health-Different Approaches. IntechOpen, 2020.(Web of Science indexed).",
        doi: "https://www.intechopen.com/chapters/72859",
      },
    ],
  },
];
export default listOfBookChapters;
